import vtkAbstractRepresentationProxy from './AbstractRepresentationProxy';
import vtkLookupTableProxy from './LookupTableProxy';
import vtkPiecewiseFunctionProxy from './PiecewiseFunctionProxy';
import vtkProxyManager from './ProxyManager';
import vtkSourceProxy from './SourceProxy';
import vtkView2DProxy from './View2DProxy';
import vtkViewProxy from './ViewProxy';

export default {
  vtkAbstractRepresentationProxy,
  vtkLookupTableProxy,
  vtkPiecewiseFunctionProxy,
  vtkProxyManager,
  vtkSourceProxy,
  vtkView2DProxy,
  vtkViewProxy,
};
